var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table-render',{attrs:{"schema":_vm.schema,"rows":_vm.rows,"stickyHeader":"calc(100vh - 2.5rem)","id":"rates-costs-table","tableClass":'with-scroll'},on:{"update:schema":function($event){_vm.schema=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }